import { render, staticRenderFns } from "./ListingClosedSessions.vue?vue&type=template&id=144cd124"
import script from "./ListingClosedSessions.vue?vue&type=script&lang=js"
export * from "./ListingClosedSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports